import classNames from 'classnames';
import { useState } from 'react';
import { useHasOverflow } from '../hooks/useHasOverflow';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../styles/posts.module.css';
import { ShowMoreButton } from './showMoreButton';

export const ExpandableSummary: React.FC<{
	children: JSX.Element;
	expanded: boolean;
	setExpanded: () => void;
	height?: number;
}> = ({ children, expanded, setExpanded, height }) => {
	const [overflow, ref] = useHasOverflow();
	const [localExpanded, setLocalExpanded] = useState(false);
	// If the user has clicked the expand button, then we want to set max-height to a real value to trigger the
	// animation, if it was already expanded, then we want to set it to 'unset' so we don't trigger any animation.
	const maxHeight = localExpanded && overflow.height ? overflow.height : 'unset';

	return (
		<>
			<div
				ref={ref}
				style={{ maxHeight: expanded ? maxHeight : height || 300 }}
				className={classNames({
					[postStyles.overflow]: overflow.hasOverflow,

					[postStyles.expanded]: expanded
				})}
			>
				{children}
			</div>
			{overflow.hasOverflow && !expanded && (
				<ShowMoreButton
					onClick={() => {
						setLocalExpanded(true);
						setExpanded();
					}}
				/>
			)}
		</>
	);
};
